export type ProjectStatus = 'not_started' | 'in_progress' | 'completed' | 'on_hold' | 'cancelled';
export type TaskStatus = 'not_started' | 'in_progress' | 'completed' | 'blocked';
export type TaskPriority = 'low' | 'medium' | 'high';

export interface Project {
  id: number;
  name: string;
  description: string | null;
  status: ProjectStatus;
  is_private: boolean;
  start_date: string | null;
  end_date: string | null;
  created_by: number;
  created_at: string;
  updated_at: string;
}

export interface ProjectTask {
  id: number;
  project_id: number;
  name: string;
  description: string | null;
  status: TaskStatus;
  is_private: boolean;
  due_date: string | null;
  shift_type_id: number | null;
  estimated_hours: number | null;
  actual_hours: number | null;
  priority: TaskPriority;
  created_by: number;
  created_at: string;
  updated_at: string;
}

export interface TaskAssignee {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
}

export interface TaskWithAssignees extends ProjectTask {
  assignees: TaskAssignee[];
  shift_type?: { id: number; name: string; color: string } | null;
  project_name?: string;
}

export interface ProjectWithTasks extends Project {
  tasks: TaskWithAssignees[];
  created_by_user: { id: number; first_name: string; last_name: string };
}

export interface CreateProjectRequest {
  name: string;
  description?: string;
  status?: ProjectStatus;
  is_private?: boolean;
  start_date?: string;
  end_date?: string;
}

export interface UpdateProjectRequest {
  name?: string;
  description?: string;
  status?: ProjectStatus;
  is_private?: boolean;
  start_date?: string | null;
  end_date?: string | null;
  status_notes?: string;
}

export interface CreateTaskRequest {
  project_id: number;
  name: string;
  description?: string;
  status?: TaskStatus;
  is_private?: boolean;
  due_date?: string;
  shift_type_id?: number;
  estimated_hours?: number;
  actual_hours?: number;
  priority?: TaskPriority;
}

export interface UpdateTaskRequest {
  name?: string;
  description?: string;
  status?: TaskStatus;
  is_private?: boolean;
  due_date?: string | null;
  shift_type_id?: number | null;
  estimated_hours?: number | null;
  actual_hours?: number | null;
  priority?: TaskPriority;
}

export interface ProjectStatusHistoryEntry {
  id: number;
  project_id: number;
  old_status: string | null;
  new_status: string;
  changed_by: number;
  changed_at: string;
  notes: string | null;
}

export const PROJECT_STATUS_LABELS: Record<ProjectStatus, string> = {
  not_started: 'Not Started',
  in_progress: 'In Progress',
  completed: 'Completed',
  on_hold: 'On Hold',
  cancelled: 'Cancelled',
};

export const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
  not_started: 'Not Started',
  in_progress: 'In Progress',
  completed: 'Completed',
  blocked: 'Blocked',
};

export const TASK_PRIORITY_LABELS: Record<TaskPriority, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
};
